(() => {
  'use strict';
  if (window.AWConfiguratorExactModelPersistence?.version) return;

  const KEYS = {
    configurator: 'aw_airsoft_configurator',
    saved: 'aw_airsoft_saved_configurations',
    modelMap: 'aw_saved_config_models_v1',
    context: 'aw_airsoft_context_v1',
    exact: 'aw_exact_model_context_v1'
  };

  const normalize = (value = '') => String(value || '').trim().toLowerCase().normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '').replace(/&/g, ' et ').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const readJson = (key, fallback) => {
    try { return JSON.parse(localStorage.getItem(key) || 'null') ?? fallback; }
    catch (_) { return fallback; }
  };
  const writeJson = (key, value) => {
    try { localStorage.setItem(key, JSON.stringify(value)); return true; }
    catch (_) { return false; }
  };
  const exactContext = () => {
    const bridge = window.AWModelContextBridge?.currentExact?.();
    if (bridge?.handle) return bridge;
    const exact = readJson(KEYS.exact, {});
    if (exact?.status === 'exact' && exact.handle) return exact;
    const shared = readJson(KEYS.context, {});
    if (shared?.modelHandle && (shared.modelStatus === 'exact' || shared.model || shared.modelLabel)) {
      return {
        status: 'exact',
        handle: String(shared.modelHandle || ''),
        label: String(shared.modelLabel || shared.model || ''),
        model: String(shared.model || shared.modelLabel || ''),
        manufacturer: String(shared.manufacturer || ''),
        manufacturerLabel: String(shared.manufacturerLabel || shared.manufacturer || ''),
        platform: String(shared.platform || ''),
        platformLabel: String(shared.platformLabel || shared.platform || ''),
        type: String(shared.type || ''),
        typeLabel: String(shared.typeLabel || shared.type || ''),
        pageUrl: ''
      };
    }
    return null;
  };
  const baseMatches = (project, exact) => {
    if (!project || !exact?.handle) return false;
    if (!project.platform || normalize(project.platform) !== normalize(exact.platform || exact.platformLabel || '')) return false;
    const projectMaker = normalize(project.manufacturer || '');
    const exactMaker = normalize(exact.manufacturer || exact.manufacturerLabel || '');
    if (projectMaker && exactMaker && projectMaker !== exactMaker) return false;
    const projectType = normalize(project.type || '');
    const exactType = normalize(exact.type || exact.typeLabel || '');
    if (projectType && exactType && projectType !== exactType) return false;
    return true;
  };
  const mappingRecord = (exact) => ({
    handle: String(exact.handle || '').trim(),
    label: String(exact.label || exact.model || '').trim(),
    model: String(exact.model || exact.label || '').trim(),
    manufacturer: String(exact.manufacturer || exact.manufacturerLabel || '').trim(),
    platform: String(exact.platform || '').trim(),
    platformLabel: String(exact.platformLabel || exact.platform || '').trim(),
    type: String(exact.type || exact.typeLabel || '').trim(),
    pageUrl: String(exact.pageUrl || '').trim(),
    savedAt: new Date().toISOString(),
    source: 'configurator-exact-model-save'
  });

  let pending = null;
  const captureBeforeSave = (button) => {
    const root = button.closest('[data-aw-configurator]');
    if (!root) return;
    const savedKey = root.dataset.savedKey || KEYS.saved;
    const configuratorKey = root.dataset.storageKey || KEYS.configurator;
    const before = readJson(savedKey, []);
    const state = readJson(configuratorKey, {});
    const exact = exactContext();
    pending = {
      root,
      savedKey,
      configuratorKey,
      beforeIds: new Set((Array.isArray(before) ? before : []).map((item) => String(item?.id || '')).filter(Boolean)),
      previousSavedId: String(state?.savedId || ''),
      exact,
      capturedAt: Date.now()
    };
  };

  const persistAfterSave = () => {
    const snapshot = pending;
    pending = null;
    if (!snapshot || Date.now() - snapshot.capturedAt > 5000 || !snapshot.exact?.handle) return false;
    const saved = readJson(snapshot.savedKey, []);
    if (!Array.isArray(saved) || !saved.length) return false;
    const state = readJson(snapshot.configuratorKey, {});
    const newItems = saved.filter((item) => item?.id && !snapshot.beforeIds.has(String(item.id)));
    let project = null;

    if (newItems.length === 1) project = newItems[0];
    if (!project && state?.savedId) project = saved.find((item) => String(item?.id || '') === String(state.savedId));
    if (!project && snapshot.previousSavedId) project = saved.find((item) => String(item?.id || '') === snapshot.previousSavedId);
    if (!project && saved[0]?.id) project = saved[0];
    if (!project?.id || !baseMatches(project, snapshot.exact)) return false;

    const map = readJson(KEYS.modelMap, {});
    const next = map && typeof map === 'object' && !Array.isArray(map) ? { ...map } : {};
    next[String(project.id)] = mappingRecord(snapshot.exact);
    if (!writeJson(KEYS.modelMap, next)) return false;

    try {
      window.dispatchEvent(new CustomEvent('aw:project-model-mapped', {
        detail: { projectId: String(project.id), modelHandle: snapshot.exact.handle }
      }));
    } catch (_) {}
    try { window.AWModelContextBridge?.patchProjectLinks?.(); } catch (_) {}
    return true;
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-aw-save-confirm]');
    if (!button) return;
    captureBeforeSave(button);
    [0, 40, 120].forEach((delay) => window.setTimeout(() => {
      if (pending) persistAfterSave();
    }, delay));
  }, true);

  window.addEventListener('aw:project-model-mapped', () => {
    try { window.AWModelContextBridge?.patchProjectLinks?.(); } catch (_) {}
  });

  window.AWConfiguratorExactModelPersistence = {
    version: '1.0.0',
    exactContext,
    baseMatches,
    persistAfterSave,
    policy: 'persist-only-after-real-save-and-base-match;never-infer-exact-model'
  };
})();
